import React, { Fragment, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { HiChevronRight, HiOutlineMenuAlt2 } from 'react-icons/hi';
import { Dialog, Transition } from '@headlessui/react';
import { IoChevronDown, IoClose } from "react-icons/io5"
import { Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react';

const Header = () => {
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()
    return (
        <div>
            <div className='bg-gray-300 xl:px-[60px] px-[20px] md:py-[30px] py-[13px]'>
                <div className='flex justify-between items-center'>
                    <div className='lg:flex hidden xl:gap-[40px] gap-[15px] uppercase'>
                        <Link to='/' className='font-semibold text-gray-700 xl:text-base text-sm cursor-pointer tracking-wide'>Home</Link>
                        <Link to='/' className='font-semibold text-gray-700 xl:text-base text-sm cursor-pointer tracking-wide'>Blog</Link>
                        <Link to='/' className='font-semibold text-gray-700 xl:text-base text-sm cursor-pointer tracking-wide'>Service</Link>
                        <Menu>
                            <MenuHandler>
                                <Link to='/' className='font-semibold text-gray-700 xl:text-base text-sm cursor-pointer tracking-wide flex items-center gap-1'>products <IoChevronDown /></Link>
                            </MenuHandler>
                            <MenuList className='p-1'>
                                <MenuItem className='uppercase font-semibold'>PaySA</MenuItem>
                                <MenuItem className='uppercase font-semibold'>Paysa-CardPay</MenuItem>
                                <MenuItem className='uppercase font-semibold'>Paysa-BANKPay</MenuItem>
                            </MenuList>
                        </Menu>
                        <Link to='/' className='font-semibold text-gray-700 xl:text-base text-sm cursor-pointer tracking-wide'>portal</Link>
                        <Link to='/' className='font-semibold text-gray-700 xl:text-base text-sm cursor-pointer tracking-wide'>contact us</Link>
                        <Menu>
                            <MenuHandler>
                                <Link to='/' className='font-semibold text-gray-700 xl:text-base text-sm cursor-pointer tracking-wide flex items-center gap-1'>solutions<IoChevronDown /></Link>
                            </MenuHandler>
                            <MenuList className='p-1'>
                                <MenuItem className='uppercase font-semibold'>Accelerator</MenuItem>
                                <MenuItem className='uppercase font-semibold'>Services</MenuItem>
                            </MenuList>
                        </Menu>
                        <Link to='/' className='font-semibold text-gray-700 xl:text-base text-sm cursor-pointer tracking-wide'>gen ai</Link>
                    </div>
                    <div className='lg:hidden block cursor-pointer' onClick={() => setOpen(true)}>
                        <HiOutlineMenuAlt2 className='text-[20px] text-gray-700' />
                    </div>
                    <button className='flex items-center gap-2 rounded-full w-max text-gray-700 bg-[#ffffff99] lg:px-[20px] px-[15px] py-[5px] font-medium lg:text-[16px] text-[14px]' onClick={() => navigate('/signIn')}>Sign In<HiChevronRight /></button>
                </div>
            </div>
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <div className="fixed inset-0 bg-black opacity-25" />

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pr-10">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-700"
                                    enterFrom="translate-x-[-100%]"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-[-100%]"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-sm">
                                        <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                            <div className="px-4 sm:px-6">
                                                <div className="flex items-start justify-between">
                                                    <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                                                        Logo
                                                    </Dialog.Title>
                                                    <div className="ml-3 flex h-7 items-center">
                                                        <button
                                                            type="button"
                                                            className="text-gray-400 focus:outline-none"
                                                            onClick={() => setOpen(false)}
                                                        >
                                                            <IoClose className="h-6 w-6" aria-hidden="true" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="relative mt-10 flex-1 px-4 sm:px-6">
                                                <div className='flex flex-col gap-[15px] uppercase'>
                                                    <Link to='/' className='font-semibold text-gray-700 text-sm cursor-pointer tracking-wide'>Home</Link>
                                                    <Link to='/' className='font-semibold text-gray-700 text-sm cursor-pointer tracking-wide'>Blog</Link>
                                                    <Link to='/' className='font-semibold text-gray-700 text-sm cursor-pointer tracking-wide'>Service</Link>
                                                    <Menu>
                                                        <MenuHandler>
                                                            <Link to='/' className='font-semibold text-gray-700 xl:text-base text-sm cursor-pointer tracking-wide flex items-center gap-2'>products <IoChevronDown /></Link>
                                                        </MenuHandler>
                                                        <MenuList className='p-1'>
                                                            <MenuItem className='uppercase font-semibold'>PaySA</MenuItem>
                                                            <MenuItem className='uppercase font-semibold'>Paysa-CardPay</MenuItem>
                                                            <MenuItem className='uppercase font-semibold'>Paysa-BANKPay</MenuItem>
                                                        </MenuList>
                                                    </Menu>
                                                    <Link to='/' className='font-semibold text-gray-700 text-sm cursor-pointer tracking-wide'>portal</Link>
                                                    <Link to='/' className='font-semibold text-gray-700 text-sm cursor-pointer tracking-wide'>contact us</Link>
                                                    <Menu>
                                                        <MenuHandler>
                                                            <Link to='/' className='font-semibold text-gray-700 xl:text-base text-sm cursor-pointer tracking-wide flex items-center gap-2'>solutions<IoChevronDown /></Link>
                                                        </MenuHandler>
                                                        <MenuList className='p-1'>
                                                            <MenuItem className='uppercase font-semibold'>Accelerator</MenuItem>
                                                            <MenuItem className='uppercase font-semibold'>Services</MenuItem>
                                                        </MenuList>
                                                    </Menu>
                                                    <Link to='/' className='font-semibold text-gray-700 text-sm cursor-pointer tracking-wide'>gen ai</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default Header